/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCrmAuthUrlResponse } from '../../models/api-response-crm-auth-url-response';
import { CrmConnectRequest } from '../../models/crm-connect-request';

export interface Connect$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body?: CrmConnectRequest
}

export function connect(http: HttpClient, rootUrl: string, params: Connect$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCrmAuthUrlResponse>> {
  const rb = new RequestBuilder(rootUrl, connect.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCrmAuthUrlResponse>;
    })
  );
}

connect.PATH = '/v1/api/ui/zoho-crm/connect';
